import type { Attachment } from '@/models/attachment';
import { AttachmentItem } from './AttachmentItem';
import styles from './AttachmentRail.module.css';

interface AttachmentRailProps {
  attachments: Attachment[];
  selectedId: string | null;
  onSelect: (uuid: string) => void;
  isLoading: boolean;
}

export default function AttachmentRail({
  attachments,
  selectedId,
  onSelect,
  isLoading,
}: AttachmentRailProps) {
  if (isLoading) {
    return (
      <div className={styles.rail}>
        <p className={styles.empty}>Loading attachments...</p>
      </div>
    );
  }

  if (attachments.length === 0) {
    return (
      <div className={styles.rail}>
        <p className={styles.empty}>No attachments available</p>
      </div>
    );
  }

  return (
    <div className={styles.rail}>
      <div className={styles.list}>
        {attachments.map((attachment) => (
          <AttachmentItem
            key={attachment.uuid}
            attachment={attachment}
            isSelected={attachment.uuid === selectedId}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
